/**
 * Central config for World Cup round visibility.
 *
 * `ACTIVE_FROM_MD` — the earliest round shown in any picker/switcher UI.
 * Once a round is in progress / finished, bump this so users land on the
 * next playable round by default. Direct URLs (`/play/round-call/1`)
 * still work for history viewing — this only governs UI navigation.
 */
export const ACTIVE_FROM_MD = 2;

export const ALL_ROUNDS = [
    { n: 1, label: "R1" }, { n: 2, label: "R2" }, { n: 3, label: "R3" },
    { n: 4, label: "R32" }, { n: 5, label: "R16" },
    { n: 6, label: "QF" }, { n: 7, label: "SF" }, { n: 8, label: "Final" },
];

export const ACTIVE_ROUNDS = ALL_ROUNDS.filter((r) => r.n >= ACTIVE_FROM_MD);

export const DEFAULT_MD_PATH = `/play/round-call/${ACTIVE_FROM_MD}`;
export const DEFAULT_ADMIN_MD_PATH = `/worldcup/matchday/${ACTIVE_FROM_MD}`;
